import DragIndicator from "@material-ui/icons/DragIndicator";

export const DragIndicatorIcon = DragIndicator;